// extracted by mini-css-extract-plugin
export default {"passwordRules":"components-PasswordUpdate-___passwordUpdate__passwordRules___kt_cH"};